export const API_URL = process.env.REACT_APP_API_URL;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const instId = process.env.REACT_APP_INST_ID;
export const currency = process.env.REACT_APP_CURRENCY;
export const WEB_URL = process.env.REACT_APP_WEB_URL;
